import { primaryCategories } from './Categories';

interface ImageMap {
  [key: string]: string;
}

const coverImageMap: ImageMap = {
  [primaryCategories.FAMILY_AND_INHERITANCE_LAW]: 'henkilo_perhe_ja_perinto',
  [primaryCategories.PUBLIC_LAW]: 'julkisoikeus',
  [primaryCategories.CRIMINAL_AND_PROCEDURAL_LAW]: 'rikos_ja_prosessi',
  [primaryCategories.CONTRACTS]: 'sopimus_ja_velkasuhteet',
  [primaryCategories.LABOUR_LAW_AND_HR]: 'tyooikeus_ja_hr',
  [primaryCategories.TAXATION]: 'verotus',
  [primaryCategories.HOUSING_ENVIRONMENT_AND_CONSTRUCTION]:
    'ymparisto_asuminen_ja_rakentaminen',
  [primaryCategories.ENTERPRISES_AND_COMMUNITIES]: 'yritykset_ja_yhteisot',
};

/**
 * Get cover image for a theme. Returns a default image is no cover for the
 * given theme is defined.
 */
export function getImageByTheme(theme?: string) {
  if (theme && Object.keys(coverImageMap).includes(theme)) {
    return coverImageMap[theme] + '.png';
  }

  return 'suomen_laki.png'; // @TODO: Change default cover image
}

/**
 * Get cover image for a theme. Returns a default image is no cover for the
 * given theme is defined.
 */
export function getIconByTheme(theme?: string) {
  if (theme && Object.keys(coverImageMap).includes(theme)) {
    return coverImageMap[theme] + '.svg';
  }

  return 'kaikki_aihealueet.svg';
}
